module.exports = require("lodash/object");